export enum EQuantityFormatKey {
  PRODUCTS = 'productsQuantityFormat',
  BALANCE = 'balanceQuantityFormat',
  SPECIAL_OFFER = 'specialOfferQuantityFormat',
  ROLLING_OFFER = 'rollingOfferQuantityFormat',
  PROGRESS_BAR = 'progressBarQuantityFormat',
  TRIGGERED_POPUP = 'triggeredPopupQuantityFormat'
}

export enum EQuantityFieldControl {
  SEPARATOR = 'separator',
  BOOLEAN = 'boolean',
  NUMBER = 'number'
}

export enum ETimeFormatKey {
  PRODUCTS = 'productsTimeFormat',
  BALANCE = 'balanceTimeFormat',
  SPECIAL_OFFER = 'specialOfferTimeFormat',
  ROLLING_OFFER = 'rollingOfferTimeFormat',
  PROGRESS_BAR = 'progressBarTimeFormat',
  TRIGGERED_POPUP = 'triggeredPopupTimeFormat'
}

export enum ETimeBaseUnit {
  DAYS = 'days',
  HOURS = 'hours',
  MINUTES = 'minutes',
  SECONDS = 'seconds'
}

export enum ETimeAbbreviationStyle {
  SHORT = 'short',
  LONG = 'long'
}

export interface ITimeFormat {
  baseUnitThreshold: number;
  baseUnit: ETimeBaseUnit;
  abbreviationStyle: ETimeAbbreviationStyle;
}

export interface IQuantityFormat {
  milSeparator: string;
  fractionalSeparator: string;
  thousandShorthand: boolean;
  millionShorthand: boolean;
  billionShorthand: boolean;
  trillionShorthand: boolean;
  quadrillionShorthand: boolean;
  quintillionShorthand: boolean;
  sextillionShorthand: boolean;
  septillionShorthand: boolean;
  digitsBasedAbbreviation: boolean;
  maxDigitsWithoutShorthand: number;
}

export interface IStoreSettingsFormValues {
  productsQuantityFormat: IQuantityFormat;
  balanceQuantityFormat: IQuantityFormat;
  specialOfferQuantityFormat: IQuantityFormat;
  rollingOfferQuantityFormat: IQuantityFormat;
  progressBarQuantityFormat: IQuantityFormat;
  triggeredPopupQuantityFormat: IQuantityFormat;
  productsTimeFormat: ITimeFormat;
  balanceTimeFormat: ITimeFormat;
  specialOfferTimeFormat: ITimeFormat;
  rollingOfferTimeFormat: ITimeFormat;
  progressBarTimeFormat: ITimeFormat;
  triggeredPopupTimeFormat: ITimeFormat;
}

export interface IQuantityFieldDescriptor {
  key: keyof IQuantityFormat;
  header: string;
  control: EQuantityFieldControl;
  gridSize: number;
}

export interface IQuantityFormatSection {
  key: EQuantityFormatKey;
  title: string;
}
